import { useMutation } from "react-query";
import { useGlobalToast } from "components/GlobalToastProvider";
import { cancelVideoCallAsync } from "api/appointments";

const useCancelVideoCall = (options = {}) => {
  const { onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading } = useMutation((payload) => cancelVideoCallAsync(payload), {
    onError: () => {
      showToast({
        message: "Error updating appointment",
        errorState: true,
      });
      onError();
    },
    ...otherOptions,
  });

  return {
    cancelVideoCall: mutate,
    isCancelVideoCallLoading: isLoading,
  };
};

export default useCancelVideoCall;
